import React from 'react';
import {Controller, useFormContext} from "react-hook-form";

const FormField = ({ name, as: Component, customRender, ...props }) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                if (customRender) {
                    return customRender(field);
                }

                return <Component id={name} {...field} {...props} />
            }}
        />
    );
};

export default FormField;